<div class="dxc-time__box" [class.is-invalid]="invalid" [class.is-disabled]="disabled">
  <span class="dxc-time__icon" aria-hidden="true">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"
      stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="8.25"/><path d="M12 7.25V12l3.25 2"/>
    </svg>
  </span>

  <span class="dxc-time__digits">
    <input #hh type="text" class="dxc-time__input" inputmode="numeric" maxlength="2"
      autocomplete="off" placeholder="--" aria-label="Hora"
      [id]="fieldId" [disabled]="disabled" [value]="hours"
      (input)="onHours($any($event.target).value)" (blur)="onBlur()"
      (focus)="$any($event.target).select()">
    <span class="dxc-time__colon" aria-hidden="true">:</span>
    <input #mm type="text" class="dxc-time__input" inputmode="numeric" maxlength="2"
      autocomplete="off" placeholder="--" aria-label="Minutos"
      [disabled]="disabled" [value]="minutes"
      (input)="onMinutes($any($event.target).value)" (keydown)="onMinutesKeydown($event)"
      (blur)="onBlur()" (focus)="$any($event.target).select()">
  </span>

  <!-- Segmentado y no un botón que alterna: los dos estados se ven a la vez, así
       que no hay que pulsar para saber cuál está puesto. -->
  <span class="dxc-time__meridiem" role="group" [attr.aria-label]="ariaLabel || 'Meridiano'">
    <button type="button" [disabled]="disabled" [attr.aria-pressed]="meridiem === 'AM'"
      (click)="setMeridiem('AM')">AM</button>
    <button type="button" [disabled]="disabled" [attr.aria-pressed]="meridiem === 'PM'"
      (click)="setMeridiem('PM')">PM</button>
  </span>
</div>
